import { useEffect, useState } from "react";

function getBtnSuffix(
    size: "sm" | "lg" | undefined | null,
    variant: string | undefined | null,
    color: string | undefined | null = null,
) {
    let key = "";

    if (variant) {
        if (variant == "outline") {
            key += " loop-btn-outline";
        } else if (variant == "underline") {
            key += " loop-btn-underline";
        } else if (variant == "nav") {
            key += " loop-btn-nav";
        } else if (variant == "input") {
            key += " loop-btn-input";
        } else if (variant == "upsell") {
            key += " loop-btn-upsell";
        } else if (variant == "banner-primary") {
            key += " loop-btn-banner-primary";
        } else if (variant == "banner-underline") {
            key += " loop-btn-banner-underline";
        }
    } else {
        key += " loop-btn-primary";
    }

    if (size == "lg") {
        key += " loop-btn-size-lg";
    } else if (size == "sm") {
        key += " loop-btn-size-sm";
    } else if (size == "md") {
        key += " loop-btn-size-md";
    }

    if (color) {
        key += " loop-btn-color-" + color;
    }

    return key;
}

type ButtonProps = {
    variant:
        | undefined
        | "primary"
        | "underline"
        | "outline"
        | "banner-underline"
        | "banner-primary"
        | "upsell";
    size: undefined | "sm" | "lg" | "md";
    color: undefined;
    className: string | undefined;
    id: string | undefined;
};

function Button(props: ButtonProps | any) {
    const [classNames, setclassNames] = useState("");

    useEffect(() => {
        let _classNames =
            "loop-btn" + getBtnSuffix(props.size, props.variant, props.color);
        if (props.className) {
            _classNames += " " + props.className;
        }
        setclassNames(_classNames);
    }, []);

    return (
        <button
            className={classNames}
            onClick={props.onClick ? props.onClick : () => {}}
            disabled={props.disabled ? props.disabled : false}
            id={props.id ? props.id : null}
        >
            {props.children}
        </button>
    );
}

export function ButtonNew(props: ButtonProps | any) {
    const [classNames, setclassNames] = useState("");

    useEffect(() => {
        let _classNames =
            "loop-btn" + getBtnSuffix(props.size, props.variant, props.color);
        if (props.className) {
            _classNames += " " + props.className;
        }
        setclassNames(_classNames);
    }, [props]);

    return (
        <button
            className={classNames}
            onClick={props.onClick ? props.onClick : () => {}}
            disabled={props.disabled ? props.disabled : false}
            id={props.id ? props.id : null}
        >
            {props.children}
        </button>
    );
}

export default Button;
